interface HoursFullWidthCellProps {
  colSpan: number;
  children: React.ReactNode;
}

/**
 * A cell across the whole table whose content stays in view. On a narrow
 * screen the table scrolls sideways and a spanning cell is as wide as the
 * table, so right-aligned buttons ended off-screen. The content is instead
 * exactly as wide as the scroll area (`100cqw`, measured against the
 * `HoursTable` wrapper, the query container) and sticks to its left edge.
 */
export default function HoursFullWidthCell({
  colSpan,
  children,
}: HoursFullWidthCellProps): JSX.Element {
  return (
    <td colSpan={colSpan} className="p-[0]">
      <div className="sticky left-[0] w-[100cqw] px-12 pb-12 pt-[0]">{children}</div>
    </td>
  );
}
